import React from 'react';
import { CardBoxContainer } from '../../containers';
import { IProps } from './types';
import * as S from './styles';
import { Title } from '../../atoms';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const SidebarMenu: React.FC<IProps> = ({
    items,
    title,
}) => {
    return (
        <CardBoxContainer>
            <S.Container>
                <S.HeaderContainer>
                    <Title color='text-white' colorDark='text-white' heading="h5">{title}</Title>
                </S.HeaderContainer>
                <S.ItemsContent>
                    {
                        items.map((item, ix) => (
                            !item.isExternal ?
                                <Link className="block py-2 pl-6 w-full cursor-pointer dark:text-white hover:bg-gpas-500 hover:dark:bg-gpas-600 hover:text-white transition-all transform hover:font-semibold" to={item.url} key={ix}>
                                    <FontAwesomeIcon icon={item.icon} className="text-gpas-700 hover:text-white mr-2" />
                                    <span className="text-sm">
                                        {item.title}
                                    </span>
                                </Link> :
                                <a className="block py-2 pl-6 w-full cursor-pointer dark:text-white hover:bg-gpas-500 hover:dark:bg-gpas-600 hover:text-white transition-all transform hover:font-semibold" href={item.url} key={ix}>
                                    <FontAwesomeIcon icon={item.icon} className="text-gpas-700 mr-2" />
                                    <span className="text-sm">
                                        {item.title}
                                    </span>
                                </a>
                        ))
                    }
                </S.ItemsContent>
            </S.Container>
        </CardBoxContainer>
    );
}